import { useContext } from 'react';

import { ContractBuilderContext } from 'src/context/contractBuilderContext';

import { AutofillInputs } from './AutofillInputs';
import { SelectedRecipientInfoInputs } from './SelectedRecipientInfoInputs';
import { VariableInputs } from './VariableInputs';

export const AdvancedInputs = () => {
  const { isOneOffContract } = useContext(ContractBuilderContext);

  return (
    <div className="px-1">
      {isOneOffContract ? <SelectedRecipientInfoInputs /> : <AutofillInputs />}
      {!isOneOffContract && <VariableInputs />}
    </div>
  );
};
